<template>
  <el-dropdown szie="mini" @command="handleCommand">
    <span class="el-dropdown-link more_icons">
      <i class="fa-solid fa-gear hover-b"  v-if="name == 'projects'"></i>
      <i class="el-icon-arrow-down el-icon-more-outline" v-else></i>
    </span>
    <el-dropdown-menu slot="dropdown" size="mini">      
      <el-dropdown-item v-if="permissions.some(per => per.slug == (permissionShow)) && actions.some(action => action == 'edit') ? true : false" command="edit"   icon="el-icon-edit el-icon--left">       
        {{ $t("message.update") }}
      </el-dropdown-item>
		<el-dropdown-item v-if="model.has_provider && actions.some(action => action == 'serviceProvider') ? true : false" command="serviceProvider" icon="el-icon-s-operation el-icon--left">
			{{ $t('message.service_provider') }}
		</el-dropdown-item>
		<el-dropdown-item v-if="!model.status_archived && actions.some(action => action == 'archivate') ? true : false" command="archivate"   icon="el-icon-takeaway-box el-icon--left">       
        {{ $t("message.archivate") }}
      </el-dropdown-item>
		<el-dropdown-item v-if="name == 'clients'" command="comment"  icon="el-icon-s-comment el-icon--left">      
        {{ $t("message.comment") }}
      </el-dropdown-item>
      <el-dropdown-item v-if="permissions.some(per => per.slug == (permissionDestroy)) && actions.some(action => action == 'delete')  ? true : false" command="delete" icon="el-icon-delete el-icon--left">
        {{ $t("message.delete") }}
      </el-dropdown-item>
      <el-dropdown-item v-if="permissions.some(per => per.slug == (name+'@'+'assign_role')) && actions.some(action => action == 'assign_role')  ? true : false" command="assignRole"  icon="el-icon-edit el-icon--left">       
        {{ $t("message.assign_role") }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
  import {mapGetters} from "vuex";
  export default {
    props: {
      model: {
        type: Object,
        required: true
      },
      actions: {
        type: Array
      },
      name: {
        type: String,
        required: false
      },
      permissionShow:{
          type: String,
          required: false,
          default: 'AuthenticateController@login'
      },
      permissionDestroy:{
          type: String,
          required:false,
          default: 'AuthenticateController@login'
      },
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters({
        permissions: "auth/permissions"
      })
    },
    methods: {
      handleCommand(command) {
        if (command === "delete") {
          this.$confirm(
              this.$t('message.do_you_really_want_to_do_this'),
              this.$t("message.warning"), {
                confirmButtonText: this.$t("message.yes"),
                cancelButtonText: this.$t("message.no"),
                type: "warning"
              }
            )
            .then(() => {
              this.$emit(command, this.model);
            })
            .catch(() => {
              this.$message({
                type: "warning",
                message: this.$t("message.operation_canceled")
              });
            });
        } else {          
          this.$emit(command, this.model);
        }
      }, 
      
    }
  };

</script>
